import { combineReducers } from 'redux-immer'
import produce from 'immer'

import user from './user.reducer'
import coworking from './coworking.reducer'
import review from './review.reducer'
import feedback from './feedback.reducer'
import supportRequest from './supportRequest.reducer'
import singleWorkstations from './singleWorkstations.reducer'
import meetingRooms from './meetingRooms.reducer'
import options from './options.reducer'
import contactUs from './contactUs.reducers'

const rootReducer = combineReducers(produce, {
    coworking,
    user,
    review,
    feedback,
    supportRequest,
    singleWorkstations,
    meetingRooms,
    options,
    contactUs,
})

export default rootReducer
